import { ref, watchEffect, type Ref } from 'vue'

/**
 * Реализует hover событие
 *
 * @param {vueRef} el - ссылка на элемент
 * @param {handler} handler - функция вызываемая при изменении hover состояния
 *
 * @returns
 *    state - реактивная boolean переменная hover состояния
 */
export default function (el: Ref<null | HTMLElement>, handler: (val: boolean) => void = () => {}) {
	const state = ref(false)

	const mouseenter = () => {
		if (!state.value) {
			state.value = true
			handler(true)
		}
	}
	const mouseleave = () => {
		if (state.value) {
			state.value = false
			handler(false)
		}
	}

	watchEffect(() => {
		if (el.value) {
			el.value.addEventListener('mouseenter', mouseenter)
			el.value.addEventListener('mouseleave', mouseleave)
		} else {
			mouseleave()
		}
	})

	return {
		state
	}
}
